import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { LossLimitValue } from '../../../../types/responsibleGamingLimits';
import type { Limits, LossLimitType } from '../../../../types/responsibleGamingLimits';
import { getLossLimitAmountRestrictions } from '../../../../utils/responsibleGamingLimits';
import Container from '../../../Container/Container';
import ResponsibleGamingLimits from '../../../ResponsibleGamingLimits/ResponsibleGamingLimits';

import {
  TXTWCL_Loss_Limit_1,
  TXTWCL_Loss_limit_is_a_cap_on_how_muc_ELL,
  TXTWCL_Net_Loss_Limits,
  TXTWCL_Responsible_Gaming_Limits,
  TXTWCL_You_need_to_set_at_least_one_l_ELL,
  TXTWCL_Your_net_loss_covers_your_winn_ELL
} from './RMFLossLimit.messages.json';

const filterLimits = (limits?: LossLimitType[]) =>
  limits?.filter(
    (limit) =>
      limit.type === LossLimitValue.Daily ||
      limit.type === LossLimitValue.Weekly ||
      limit.type === LossLimitValue.Monthly
  ) ?? [];

const RMFLossLimit: React.FC = () => {
  const request = useRequest();
  const siteId = useSelector(select.cms.getSiteId);
  const isGreece = siteId === Sites.GR;
  const {
    data: { lossLimits }
  } = useWizardContext();

  const initial =
    isGreece && lossLimits
      ? getLossLimitAmountRestrictions(filterLimits(lossLimits))
      : ({} as Limits);
  const [limits, setLimits] = useState<Limits>(initial);

  useEffect(() => {
    if (isGreece) return;
    request({ service: 'responsiblegaming.allapprovedlimits' }).subscribe(({ body }) => {
      setLimits(getLossLimitAmountRestrictions(filterLimits(body?.limits)));
    });
  }, [isGreece, request]);

  const subtitle = isGreece ? (
    <>
      <Translation {...TXTWCL_Your_net_loss_covers_your_winn_ELL} />
      <Translation {...TXTWCL_You_need_to_set_at_least_one_l_ELL} />
    </>
  ) : (
    <Translation {...TXTWCL_Loss_limit_is_a_cap_on_how_muc_ELL} />
  );

  return (
    <Container
      page={RMFLossLimit}
      headerProps={{ title: <Translation {...TXTWCL_Responsible_Gaming_Limits} /> }}
      pageTopTitle={<Translation {...(isGreece ? TXTWCL_Net_Loss_Limits : TXTWCL_Loss_Limit_1)} />}
      pageTopSubtitle={subtitle}
    >
      <ResponsibleGamingLimits fieldName="rmf.loss" limits={limits} />
    </Container>
  );
};

RMFLossLimit.displayName = 'RMFLossLimit';

export default RMFLossLimit;
